// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ReactNode } from "react";

type HandlerType = Handler<{ breadcrumbActions: ReactNode }>;

export const DispatchSetBreadcrumbActions: HandlerType = (props: any) => {
    props.dispatch({
        type: "xCommon/update",
        data: { key: "breadcrumbActions", value: props.parameter.breadcrumbActions },
    });
};

export const chain = [DispatchSetBreadcrumbActions];

const setBreadcrumbActions = createHandlerChainRunner(chain, "SetBreadcrumbActions");
export default setBreadcrumbActions;
